import React, { useState, useEffect, useRef } from 'react';
import { HiCheck } from 'react-icons/hi';
import { participationService } from '../../services/participationService';

function ParticipationManagement({ selectedEdition }) {
  const [participationData, setParticipationData] = useState({
    participationHeader: {
      title: 'Participation au Congrès',
      subtitle: ''
    },
    eventInfo: {
      title: 'Informations sur l\'Événement',
      congressTitle: '',
      congressDates: '',
      location: '',
      subLocation: ''
    },
    countdownInfo: {
      title: 'Compte à Rebours',
      targetDate: '',
      targetTime: '09:00',
      isActive: true
    },
    formInfo: {
      title: 'Formulaire d\'Inscription',
      submitButtonText: 'S\'inscrire',
      registrationOpen: true
    },
    additionalInfo: {
      title: 'Informations Importantes',
      notes: []
    },
    paymentPlans: {
      presentiel: [],
      online: []
    }
  });

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showSaveSuccess, setShowSaveSuccess] = useState(false);
  const [originalData, setOriginalData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isDatabaseEmpty, setIsDatabaseEmpty] = useState(false);

  useEffect(() => {
    if (selectedEdition) {
      loadParticipationData();
    }
  }, [selectedEdition]);

  useEffect(() => {
    if (originalData) {
      const hasChanges = JSON.stringify(originalData) !== JSON.stringify(participationData);
      setHasUnsavedChanges(hasChanges);
    }
  }, [participationData, originalData]);

  const loadParticipationData = async () => {
    if (!selectedEdition) return;
    
    try {
      setLoading(true);
      console.log('Loading participation data for edition:', selectedEdition);
      const data = await participationService.getParticipationData(selectedEdition);
      
      if (!data || ((!data.participationHeader?.title || data.participationHeader.title === 'Participation au Congrès') && 
                    (!data.participationHeader?.subtitle || data.participationHeader.subtitle === '') &&
                    (!data.eventInfo?.congressTitle || data.eventInfo.congressTitle === '') &&
                    (!data.eventInfo?.congressDates || data.eventInfo.congressDates === '') &&
                    (!data.eventInfo?.location || data.eventInfo.location === '') &&
                    (!data.additionalInfo?.notes || data.additionalInfo.notes.length === 0))) {
        console.log('No data found, setting defaults');
        setIsDatabaseEmpty(true);
        const defaultData = {
          participationHeader: {
            title: 'Participation au Congrès',
            subtitle: 'Inscrivez-vous pour participer au congrès'
          },
          eventInfo: {
            title: 'Informations sur l\'Événement',
            congressTitle: 'CIGSIDA 2025',
            congressDates: 'Du 20 au 21 Novembre 2025',
            location: 'Centre de Conférences',
            subLocation: 'Salle Principale'
          },
          countdownInfo: {
            title: 'Compte à Rebours',
            targetDate: new Date().toISOString().split('T')[0],
            targetTime: '09:00',
            isActive: true
          },
          formInfo: {
            title: 'Formulaire d\'Inscription',
            submitButtonText: 'S\'inscrire au Congrès',
            registrationOpen: true,
            showParticipantForm: true,
            showConferencierForm: true
          },
          additionalInfo: {
            title: 'Informations Importantes',
            notes: [
              'L\'inscription est gratuite mais obligatoire',
              'Vous recevrez une confirmation par email',
              'Présentez votre ticket à l\'entrée'
            ]
          },
          paymentPlans: {
            presentiel: [
              { id: '1', title: 'Étudiants PhD', price: '40 MAD', description: 'Accès complet en présentiel' },
              { id: '2', title: 'Professeurs', price: '70 MAD', description: 'Accès complet en présentiel' },
              { id: '3', title: 'Professionnels', price: '100 MAD', description: 'Accès complet en présentiel' }
            ],
            online: [
              { id: '4', title: 'Étudiants PhD', price: '40 MAD', description: 'Accès complet en ligne' },
              { id: '5', title: 'Professeurs', price: '70 MAD', description: 'Accès complet en ligne' },
              { id: '6', title: 'Professionnels', price: '100 MAD', description: 'Accès complet en ligne' }
            ]
          }
        };
        setParticipationData(defaultData);
        setOriginalData(JSON.parse(JSON.stringify(defaultData)));
      } else {
        console.log('Data found:', data);
        setParticipationData(data);
        setOriginalData(JSON.parse(JSON.stringify(data)));
        setIsDatabaseEmpty(false);
      }
    } catch (error) {
      console.error('Error loading participation data:', error);
      setIsDatabaseEmpty(true);
      const defaultData = {
        participationHeader: {
          title: 'Participation au Congrès',
          subtitle: 'Inscrivez-vous pour participer au congrès'
        },
        eventInfo: {
          title: 'Informations sur l\'Événement',
          congressTitle: 'CIGSIDA 2025',
          congressDates: 'Du 20 au 21 Novembre 2025',
          location: 'Centre de Conférences',
          subLocation: 'Salle Principale'
        },
        countdownInfo: {
          title: 'Compte à Rebours',
          targetDate: new Date().toISOString().split('T')[0],
          targetTime: '09:00',
          isActive: true
        },
        formInfo: {
          title: 'Formulaire d\'Inscription',
          submitButtonText: 'S\'inscrire au Congrès',
          registrationOpen: true,
          showParticipantForm: true,
          showConferencierForm: true
        },
        additionalInfo: {
          title: 'Informations Importantes',
          notes: [
            'L\'inscription est gratuite mais obligatoire',
            'Vous recevrez une confirmation par email',
            'Présentez votre ticket à l\'entrée'
          ]
        },
        paymentPlans: {
          presentiel: [
            { id: '1', title: 'Étudiants PhD', price: '40 MAD', description: 'Accès complet en présentiel' },
            { id: '2', title: 'Professeurs', price: '70 MAD', description: 'Accès complet en présentiel' },
            { id: '3', title: 'Professionnels', price: '100 MAD', description: 'Accès complet en présentiel' }
          ],
          online: [
            { id: '4', title: 'Étudiants PhD', price: '40 MAD', description: 'Accès complet en ligne' },
            { id: '5', title: 'Professeurs', price: '70 MAD', description: 'Accès complet en ligne' },
            { id: '6', title: 'Professionnels', price: '100 MAD', description: 'Accès complet en ligne' }
          ]
        }
      };
      setParticipationData(defaultData);
      setOriginalData(JSON.parse(JSON.stringify(defaultData)));
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      await participationService.updateParticipationData(participationData, selectedEdition);
      setOriginalData(JSON.parse(JSON.stringify(participationData)));
      setHasUnsavedChanges(false);
      setIsDatabaseEmpty(false);
      showSuccessMessage();
    } catch (error) {
      console.error('Error saving participation data:', error);
      alert('Erreur lors de la sauvegarde.');
    }
  };

  const handleReset = () => {
    if (originalData && window.confirm('Voulez-vous vraiment annuler toutes les modifications non sauvegardées ?')) {
      setParticipationData(JSON.parse(JSON.stringify(originalData)));
      setHasUnsavedChanges(false);
    }
  };

  const handleUpdateParticipationHeader = (field, value) => {
    setParticipationData(prev => ({
      ...prev,
      participationHeader: { 
        ...prev.participationHeader, 
        [field]: value 
      }
    }));
  };

  const handleUpdateEventInfo = (field, value) => {
    setParticipationData(prev => ({
      ...prev,
      eventInfo: { 
        ...prev.eventInfo, 
        [field]: value 
      }
    }));
  };

  const handleUpdateCountdownInfo = (field, value) => {
    setParticipationData(prev => ({
      ...prev,
      countdownInfo: { 
        ...prev.countdownInfo, 
        [field]: value 
      }
    }));
  };

  const handleUpdateFormInfo = (field, value) => {
    setParticipationData(prev => ({
      ...prev,
      formInfo: { 
        ...prev.formInfo, 
        [field]: value 
      }
    }));
  };

  const handleUpdateAdditionalInfo = (field, value) => {
    if (field === 'notes') {
      const notesArray = value.split('\n').filter(note => note.trim() !== '');
      setParticipationData(prev => ({
        ...prev,
        additionalInfo: { 
          ...prev.additionalInfo, 
          notes: notesArray 
        }
      }));
    } else {
      setParticipationData(prev => ({
        ...prev,
        additionalInfo: { 
          ...prev.additionalInfo, 
          [field]: value 
        }
      }));
    }
  };

  const handleUpdatePaymentPlan = (type, index, field, value) => {
    setParticipationData(prev => {
      const newPlans = { ...prev.paymentPlans };
      newPlans[type] = [...(newPlans[type] || [])];
      newPlans[type][index] = { ...newPlans[type][index], [field]: value };
      return { ...prev, paymentPlans: newPlans };
    });
  };

  const handleAddPaymentPlan = (type) => {
    setParticipationData(prev => {
      const newPlans = { ...prev.paymentPlans };
      newPlans[type] = [...(newPlans[type] || []), { id: Date.now().toString(), title: '', price: '', description: '' }];
      return { ...prev, paymentPlans: newPlans };
    });
  };

  const handleRemovePaymentPlan = (type, index) => {
    setParticipationData(prev => {
      const newPlans = { ...prev.paymentPlans };
      newPlans[type] = newPlans[type].filter((_, i) => i !== index);
      return { ...prev, paymentPlans: newPlans };
    });
  };

  const showSuccessMessage = () => {
    setShowSaveSuccess(true);
    setTimeout(() => setShowSaveSuccess(false), 3000);
  };

  if (!selectedEdition) {
    return <div className="admin-section">Please select an edition first</div>;
  }

  if (loading) {
    return <div className="admin-section">Loading...</div>;
  }

  return (
    <div className="admin-section">
      {/* Database Empty Warning */}
      {isDatabaseEmpty && (
        <div className="database-empty-warning">
          <div className="warning-content">
            <h3>Base de données vide pour l'édition {selectedEdition}</h3>
            <p>La base de données Participation est vide pour cette édition. Remplissez les champs ci-dessous et cliquez sur "Sauvegarder" pour initialiser les données.</p>
          </div>
        </div>
      )}

      {/* Save/Reset Actions */}
      {hasUnsavedChanges && (
        <div className="save-actions-bar">
          <div className="save-message">
            <span>Vous avez des modifications non sauvegardées</span>
          </div>
          <div className="save-buttons">
            <button onClick={handleReset} className="btn-secondary">
              Annuler les modifications
            </button>
            <button onClick={handleSave} className="btn-primary save-btn">
              <HiCheck /> Sauvegarder
            </button>
          </div>
        </div>
      )}

      {/* Success Message */}
      {showSaveSuccess && (
        <div className="save-success-message">
          <HiCheck /> Modifications sauvegardées avec succès !
        </div>
      )}

      {/* Header Section */}
      <div className="section-header">
        <h3>En-tête de la Participation</h3>
      </div>
      <div className="form-group">
        <label>Titre:</label>
        <input 
          type="text" 
          value={participationData.participationHeader.title}
          onChange={(e) => handleUpdateParticipationHeader('title', e.target.value)}
          placeholder="Ex: Participation au Congrès"
        />
      </div>
      <div className="form-group">
        <label>Sous-titre:</label>
        <input 
          type="text" 
          value={participationData.participationHeader.subtitle}
          onChange={(e) => handleUpdateParticipationHeader('subtitle', e.target.value)}
          placeholder="Ex: Inscrivez-vous pour participer au congrès"
        />
      </div>

      {/* Event Information */}
      <div className="section-header">
        <h3>Informations de l'Événement</h3>
      </div>
      <div className="form-group">
        <label>Titre de la section:</label>
        <input 
          type="text" 
          value={participationData.eventInfo.title}
          onChange={(e) => handleUpdateEventInfo('title', e.target.value)}
          placeholder="Ex: Informations sur l'Événement"
        />
      </div>
      <div className="form-group">
        <label>Titre du congrès:</label>
        <input 
          type="text" 
          value={participationData.eventInfo.congressTitle}
          onChange={(e) => handleUpdateEventInfo('congressTitle', e.target.value)}
          placeholder="Ex: CIGSIDA 2025"
        />
      </div>
      <div className="form-group">
        <label>Dates du congrès:</label>
        <input 
          type="text" 
          value={participationData.eventInfo.congressDates}
          onChange={(e) => handleUpdateEventInfo('congressDates', e.target.value)}
          placeholder="Ex: Du 20 au 21 Novembre 2025"
        />
      </div>
      <div className="form-group">
        <label>Lieu:</label>
        <input 
          type="text" 
          value={participationData.eventInfo.location}
          onChange={(e) => handleUpdateEventInfo('location', e.target.value)}
          placeholder="Ex: Centre de Conférences"
        />
      </div>
      <div className="form-group">
        <label>Sous-lieu:</label>
        <input 
          type="text" 
          value={participationData.eventInfo.subLocation}
          onChange={(e) => handleUpdateEventInfo('subLocation', e.target.value)}
          placeholder="Ex: Salle Principale"
        />
      </div>

      {/* Countdown Management */}
      <div className="section-header">
        <h3>Gestion du Compte à Rebours</h3>
      </div>
      <div className="form-group">
        <label>Titre:</label>
        <input 
          type="text" 
          value={participationData.countdownInfo.title}
          onChange={(e) => handleUpdateCountdownInfo('title', e.target.value)}
          placeholder="Ex: Compte à Rebours"
        />
      </div>
      <div className="form-group">
        <label>Date cible:</label>
        <input 
          type="date" 
          value={participationData.countdownInfo.targetDate}
          onChange={(e) => handleUpdateCountdownInfo('targetDate', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>Heure cible:</label>
        <input 
          type="time" 
          value={participationData.countdownInfo.targetTime}
          onChange={(e) => handleUpdateCountdownInfo('targetTime', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>
          <input 
            type="checkbox" 
            checked={participationData.countdownInfo.isActive}
            onChange={(e) => handleUpdateCountdownInfo('isActive', e.target.checked)}
          />
          Activer le compte à rebours
        </label>
      </div>

      {/* Form Information */}
      <div className="section-header">
        <h3>Informations du Formulaire</h3>
      </div>
      <div className="form-group">
        <label>Titre du formulaire:</label>
        <input 
          type="text" 
          value={participationData.formInfo.title}
          onChange={(e) => handleUpdateFormInfo('title', e.target.value)}
          placeholder="Ex: Formulaire d'Inscription"
        />
      </div>
      <div className="form-group">
        <label>Texte du bouton:</label>
        <input 
          type="text" 
          value={participationData.formInfo.submitButtonText}
          onChange={(e) => handleUpdateFormInfo('submitButtonText', e.target.value)}
          placeholder="Ex: S'inscrire au Congrès"
        />
      </div>
      <div className="form-group">
        <label>
          <input 
            type="checkbox" 
            checked={participationData.formInfo.registrationOpen}
            onChange={(e) => handleUpdateFormInfo('registrationOpen', e.target.checked)}
          />
          <span style={{ marginLeft: '8px', fontWeight: participationData.formInfo.registrationOpen ? 'bold' : 'normal', color: participationData.formInfo.registrationOpen ? '#1f882eff' : '#002b5b' }}>
            {participationData.formInfo.registrationOpen ? 'Inscription OUVERTE' : 'Inscription FERMÉE'}
          </span>
        </label>
        <p style={{ marginTop: '8px', fontSize: '0.9em', color: '#666' }}>
          Décochez cette case pour fermer les inscriptions. Le formulaire sera désactivé et un message sera affiché aux visiteurs.
        </p>
      </div>
      <div className="form-group">
        <label>
          <input 
            type="checkbox" 
            checked={participationData.formInfo.showParticipantForm !== false}
            onChange={(e) => handleUpdateFormInfo('showParticipantForm', e.target.checked)}
          />
          <span style={{ marginLeft: '8px' }}>
            Afficher "Participant / Visiteur"
          </span>
        </label>
      </div>
      <div className="form-group">
        <label>
          <input 
            type="checkbox" 
            checked={participationData.formInfo.showConferencierForm !== false}
            onChange={(e) => handleUpdateFormInfo('showConferencierForm', e.target.checked)}
          />
          <span style={{ marginLeft: '8px' }}>
            Afficher "Conférencier principal"
          </span>
        </label>
      </div>

      {/* Additional Information */}
      <div className="section-header">
        <h3>Informations Supplémentaires</h3>
      </div>
      <div className="form-group">
        <label>Titre:</label>
        <input 
          type="text" 
          value={participationData.additionalInfo.title}
          onChange={(e) => handleUpdateAdditionalInfo('title', e.target.value)}
          placeholder="Ex: Informations Importantes"
        />
      </div>
      <div className="form-group">
        <label>Notes (une par ligne):</label>
        <textarea 
          value={participationData.additionalInfo.notes.join('\n')}
          onChange={(e) => handleUpdateAdditionalInfo('notes', e.target.value)}
          rows="5"
          placeholder="Entrez chaque note sur une nouvelle ligne"
        />
      </div>

      {/* Payment Plans Management */}
      <div className="section-header">
        <h3>Frais de participation</h3>
      </div>
      
      {['presentiel', 'online'].map((type) => (
        <div key={type} className="payment-type-section" style={{ marginBottom: '20px', border: '1px solid #ddd', padding: '15px', borderRadius: '8px' }}>
          <h4 style={{ textTransform: 'capitalize', color: '#002b5b', marginBottom: '15px' }}>
            Participation {type === 'presentiel' ? 'en présentiel' : 'en ligne'}
          </h4>
          
          {(participationData.paymentPlans?.[type] || []).map((plan, index) => (
            <div key={plan.id || index} style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'flex-start' }}>
              <input 
                type="text" 
                placeholder="Titre (ex: Étudiants PhD)" 
                value={plan.title || ''} 
                onChange={(e) => handleUpdatePaymentPlan(type, index, 'title', e.target.value)} 
                style={{ flex: 1, padding: '8px' }}
              />
              <input 
                type="text" 
                placeholder="Prix (ex: 40 MAD)" 
                value={plan.price || ''} 
                onChange={(e) => handleUpdatePaymentPlan(type, index, 'price', e.target.value)} 
                style={{ width: '120px', padding: '8px' }}
              />
              <input 
                type="text" 
                placeholder="Description" 
                value={plan.description || ''} 
                onChange={(e) => handleUpdatePaymentPlan(type, index, 'description', e.target.value)} 
                style={{ flex: 2, padding: '8px' }}
              />
              <button 
                type="button" 
                onClick={() => handleRemovePaymentPlan(type, index)}
                style={{ background: '#002b5b', color: 'white', border: 'none', padding: '8px 12px', borderRadius: '4px', cursor: 'pointer', flexShrink: 0 }}
              >
                X
              </button>
            </div>
          ))}
          
          <button 
            type="button" 
            onClick={() => handleAddPaymentPlan(type)}
            style={{ background: '#1f882eff', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', marginTop: '10px' }}
          >
            + Ajouter un tarif
          </button>
        </div>
      ))}
    </div>
  );
}

export default ParticipationManagement;
